import styled from '@emotion/styled';

const Header = styled.h4`
    font-size: 14px;
    font-family: inherit;
    line-height: 1.2;
    color: inherit;
    margin: 5px;
`;

export default Header;
